import {
  TextInput,
  Textarea,
  Stack,
  Group,
  Button,
  NumberInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { StainProvider } from "../../../services/admin/stains.service";

export interface StainProviderFormValues {
  name: string;
  contactName: string;
  email: string;
  primaryPhone: string;
  secondaryPhone: string;
  fax: string;
  address: string;
  averageTurnaroundDays: number | "";
}

interface StainProviderFormProps {
  initialValues?: StainProvider;
  onSubmit: (values: StainProviderFormValues) => void;
  onCancel: () => void;
  submitLabel: string;
  isSubmitting?: boolean;
}

const StainProviderForm = ({
  initialValues,
  onSubmit,
  onCancel,
  submitLabel,
  isSubmitting,
}: StainProviderFormProps) => {
  const form = useForm<StainProviderFormValues>({
    initialValues: {
      name: initialValues?.name || "",
      contactName: initialValues?.contactName || "",
      email: initialValues?.email || "",
      primaryPhone: initialValues?.primaryPhone || "",
      secondaryPhone: initialValues?.secondaryPhone || "",
      fax: initialValues?.fax || "",
      address: initialValues?.address || "",
      averageTurnaroundDays: initialValues?.averageTurnaroundDays ?? "",
    },
    validate: {
      name: (value) => (!value ? "Provider name is required" : null),
    },
  });

  return (
    <form noValidate onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="md">
        <TextInput
          label="Provider Name"
          placeholder="e.g. CSI Laboratories"
          required
          {...form.getInputProps("name")}
        />

        <TextInput
          label="Contact Name"
          placeholder="Primary contact person"
          {...form.getInputProps("contactName")}
        />

        <Group grow>
          <TextInput
            label="Email"
            placeholder="orders@provider.com"
            {...form.getInputProps("email")}
          />
          <TextInput
            label="Fax"
            placeholder="813-555-1234"
            {...form.getInputProps("fax")}
          />
        </Group>

        <Group grow>
          <TextInput
            label="Primary Phone"
            placeholder="813-555-1234"
            {...form.getInputProps("primaryPhone")}
          />
          <TextInput
            label="Secondary Phone"
            placeholder="813-555-5678"
            {...form.getInputProps("secondaryPhone")}
          />
        </Group>

        <Textarea
          label="Address"
          placeholder="123 Lab Street, Tampa, FL 33601"
          minRows={2}
          {...form.getInputProps("address")}
        />

        <NumberInput
          label="Average Turnaround (days)"
          placeholder="Expected turnaround time"
          min={0}
          {...form.getInputProps("averageTurnaroundDays")}
        />

        <Group justify="flex-end" mt="md">
          <Button variant="subtle" onClick={onCancel} type="button">
            Cancel
          </Button>
          <Button type="submit" loading={isSubmitting}>
            {submitLabel}
          </Button>
        </Group>
      </Stack>
    </form>
  );
};

export default StainProviderForm;
